<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc">Contents</h1>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_int_r1.htm">Introduction</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_pre_r1.htm">Key to Symbols</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c01_r1.htm">About Last Night . . .</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c02_r1.htm">All the Real Girls</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c03_r1.htm">Annie Hall</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c04_r1.htm">Autumn Tale</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c05_r1.htm"> Beauty and the Beast</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c06_r1.htm">Before Sunrise</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c07_r1.htm">Before Sunset</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c08_r1.htm">Cousin, Cousine</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c09_r1.htm">500 Days of Summer</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c10_r1.htm">Flirting</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c11_r1.htm">Innocence</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c12_r1.htm">Lars and the Real Girl</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c13_r1.htm">Like Water for Chocolate</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c14_r1.htm">Minnie and the Moskowitz</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c15_r1.htm">Moonstruck</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c16_r1.htm">An Officer and a Gentleman</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c17_r1.htm">Once</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c18_r1.htm">Out of Africa</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c19_r1.htm">Possession</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c20_r1.htm">Pride and Prejudice</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c21_r1.htm">Say Anything</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c22_r1.htm">Scent of Green Papaya</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c23_r1.htm">Shakespeare in Love</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c24_r1.htm">Some Like It Hot</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780740792175_epub_c25_r1.htm">The Truth About Cats and Dogs</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792175_epub_toc_r1.vue?e62105ce